import type { ExternalSiteCheckRule } from "../../types";
import { decodedStartsWith } from "../../utils";
import { MAKESHOP_PAGE, SITE_TYPE } from "./const";

const isMakeshopHomePath = (pathname: string) => {
  const result = [
    "/",
    "/index.html",
    "/m",
    "/m/index.html",
    "/m/main.html",
  ].some((path) => {
    return path === pathname;
  });
  return result;
};

const makeshop: ExternalSiteCheckRule = {
  type: SITE_TYPE,

  checkPage({ url, target }) {
    const urlSearchParams = url.pathname + url.search; // 파라미터까지 비교하기 위해 사용

    if (target.value === "HOME" && isMakeshopHomePath(url.pathname)) {
      return true;
    }

    if (
      target.value === MAKESHOP_PAGE.LOGIN.target &&
      url.pathname === MAKESHOP_PAGE.LOGIN.url &&
      MAKESHOP_PAGE.LOGIN.params.every(
        ({ key, value }) => url.searchParams.get(key) === value
      )
    ) {
      return true;
    }

    if (
      target.value === MAKESHOP_PAGE.LOGIN_MY_PAGE.target &&
      url.pathname === MAKESHOP_PAGE.LOGIN_MY_PAGE.url &&
      MAKESHOP_PAGE.LOGIN_MY_PAGE.params.every(
        ({ key, value }) => url.searchParams.get(key) === value
      )
    ) {
      return true;
    }

    if (
      target.value === MAKESHOP_PAGE.SIGNUP.target &&
      url.pathname === MAKESHOP_PAGE.SIGNUP.url
    ) {
      return true;
    }

    if (
      target.value === MAKESHOP_PAGE.SIGNUP_COMPLETE.target &&
      url.pathname === MAKESHOP_PAGE.SIGNUP_COMPLETE.url
    ) {
      return true;
    }

    if (
      target.value === MAKESHOP_PAGE.FIND_PASSWORD.target &&
      url.pathname === MAKESHOP_PAGE.FIND_PASSWORD.url
    ) {
      return true;
    }

    if (
      target.value === MAKESHOP_PAGE.MY_PAGE.target &&
      url.pathname === MAKESHOP_PAGE.MY_PAGE.url
    ) {
      return true;
    }

    if (
      target.value === MAKESHOP_PAGE.FAQ.target &&
      url.pathname === MAKESHOP_PAGE.FAQ.url
    ) {
      return true;
    }

    if (
      target.value === MAKESHOP_PAGE.CART.target &&
      url.pathname === MAKESHOP_PAGE.CART.url
    ) {
      return true;
    }

    if (target.value === MAKESHOP_PAGE.PRODUCT_LIST.target) {
      const conditionPathname = target.params?.productSlug
        ? `${MAKESHOP_PAGE.PRODUCT_LIST.url}?${target.params.productSlug}`
        : `${MAKESHOP_PAGE.PRODUCT_LIST.url}`;
      if (decodedStartsWith(urlSearchParams, conditionPathname)) {
        return true;
      }
    }

    if (target.value === MAKESHOP_PAGE.PRODUCT_DETAIL.target) {
      const conditionPathname = target.params?.productSlug
        ? `${MAKESHOP_PAGE.PRODUCT_DETAIL.url}?${target.params.productSlug}`
        : `${MAKESHOP_PAGE.PRODUCT_DETAIL.url}`;
      if (decodedStartsWith(urlSearchParams, conditionPathname)) {
        return true;
      }
    }

    return false;
  },
};

export default makeshop;
